<template>
  <rabbey-top-menu />
</template>

<script>
export default {
  name: "Cmi"
};
</script>
